window.utilities = window.utilities || {};
window.utilities.cardHelpers = window.utilities.cardHelpers || {};

window.utilities.cardHelpers.transformProductMetadataToCardData = (product) => {
  if (!product || typeof product !== 'object') return null;

  const metafields = Array.isArray(product.metafields) ? product.metafields : [];

  const getMetafieldValue = (key) => {
    const entry = metafields.find((m) => m?.key === key);
    return entry?.value ?? null;
  };

  const highlightsRaw = getMetafieldValue('highlights');
  const logoBadge = getMetafieldValue('collaboration');

  const highlights =
    typeof highlightsRaw === 'string' ? highlightsRaw.split(',').map((label) => ({ label: label.trim() })) : [];

  const defaultDimensions = { width: 1000, height: 1000 };
  const featuredImageUrl = product.featuredImage?.url || '';
  const featuredImage = featuredImageUrl ? { src: featuredImageUrl, width: 1000, height: 1000 } : null;

  let image = featuredImage;
  let imageFallback = null;

  const mediaGalleryRaw = getMetafieldValue('media_gallery_assets');
  const mediaGallery = (() => {
    if (!mediaGalleryRaw) return [];
    const parsed =
      typeof mediaGalleryRaw === 'string' ? window.utilities.safeParseJSON(mediaGalleryRaw) : mediaGalleryRaw;
    return Array.isArray(parsed) ? parsed : [];
  })();

  if (mediaGallery.length > 0) {
    const contextualOrder = ['campaign-full', 'look-full', 'campaign-part', 'look-part'];
    const imageOrder = [
      'main',
      'spotlight',
      'contextual',
      'alt1',
      'alt2',
      'video',
      'alt3',
      'alt4',
      'alt5',
      'alt6',
      'contextual',
    ];

    const findByType = (type) => mediaGallery.find((e) => e?.imageType === type && e?.imageUrl);
    const getContextual = () => contextualOrder.map(findByType).find(Boolean);

    const orderedEntries = [];
    for (const order of imageOrder) {
      if (order === 'contextual') {
        const ctx = getContextual();
        if (ctx) orderedEntries.push(ctx);
      } else {
        const entry = findByType(order);
        if (entry) orderedEntries.push(entry);
      }
    }

    const videoEntry = findByType('video');
    const firstImage = orderedEntries.find((e) => e?.imageType !== 'video');

    if (videoEntry?.imageUrl) {
      image = { src: videoEntry.imageUrl, ...defaultDimensions };
      imageFallback = firstImage?.imageUrl ? { src: firstImage.imageUrl, ...defaultDimensions } : featuredImage;
    } else if (firstImage?.imageUrl) {
      image = { src: firstImage.imageUrl, ...defaultDimensions };
    }
  }

  if (!image) {
    image = { src: '', width: 1000, height: 1000 };
  }

  const price = product.priceRange?.maxVariantPrice?.amount
    ? `$${parseFloat(product.priceRange.maxVariantPrice.amount)}`
    : null;

  const compareAtPrice =
    product.compareAtPriceRange?.maxVariantPrice?.amount &&
    parseFloat(product.compareAtPriceRange.maxVariantPrice.amount) !== 0
      ? `$${parseFloat(product.compareAtPriceRange.maxVariantPrice.amount)}`
      : null;

  const flags = {
    publishDateUS: getMetafieldValue('publish_date_us'),
    publishDateCA: getMetafieldValue('publish_date_ca'),
    nonReturnableType: getMetafieldValue('non_returnable_type'),
    silhouette: getMetafieldValue('silhouette'),
    heelType: getMetafieldValue('heelType'),
    crewExclusivePriceCA: window.utilities.safeParseJSON(getMetafieldValue('crewExclusivePriceCA')),
    crewExclusivePriceUS: window.utilities.safeParseJSON(getMetafieldValue('crewExclusivePriceUS')),
    promotionalMessageUSEN: getMetafieldValue('promotional_message_us_en'),
    promotionalMessageCAEN: getMetafieldValue('promotional_message_ca_en'),
    promotionalMessageCAFR: getMetafieldValue('promotional_message_ca_fr'),
    promotionalPriceMessageUSEN: getMetafieldValue('promo_applied_message_us_en'),
    promotionalPriceMessageCAEN: getMetafieldValue('promo_applied_message_ca_en'),
    promotionalPriceMessageCAFR: getMetafieldValue('promo_applied_message_ca_fr'),
    onlineExclusive: getMetafieldValue('onlineExclusive') === 'true',
    loyaltyEarlyBuyUS: getMetafieldValue('loyaltyEarlyBuyUS'),
    loyaltyEarlyBuyEndDateUS: getMetafieldValue('loyaltyEarlyBuyEndDateUS'),
    loyaltyEarlyBuyCA: getMetafieldValue('loyaltyEarlyBuyCA'),
    loyaltyEarlyBuyEndDateCA: getMetafieldValue('loyaltyEarlyBuyEndDateCA'),
    comingSoonUS: getMetafieldValue('comingSoonUS'),
    comingSoonCA: getMetafieldValue('comingSoonCA'),
    preOrderUS: getMetafieldValue('preOrderUS'),
    preOrderCA: getMetafieldValue('preOrderCA'),
    bestsellerUS: getMetafieldValue('bestseller_us'),
    bestsellerCA: getMetafieldValue('bestseller_ca'),
    trendingUS: getMetafieldValue('trending_us'),
    trendingCA: getMetafieldValue('trending_ca'),
    isNewArrivalUS: getMetafieldValue('isNewArrivalUS'),
    newArrivalCA: getMetafieldValue('isNewArrivalCA'),
  };

  const formatted = {
    id: product.id,
    title: product.title,
    productType: product.productType,
    url: window.Shopify.routes.root + `products/${product.handle}`,
    availableForSale: product.availableForSale,
    totalInventory: product.totalInventory,
    tags: product.tags || [],
    price,
    compareAtPrice,
    image,
    imageFallback: imageFallback || undefined,
    highlights,
    flags,
    logoBadge,
  };

  return formatted;
};

window.utilities.cardHelpers.isLowStock = (data) => {
  const lowStockThreshold = window.product.lowStockValue;

  if (typeof data.totalInventory === 'number') {
    return data.totalInventory <= lowStockThreshold;
  }

  return (
    data.flags[`inventoryStock${window.Shopify.country}`] &&
    data.flags[`inventoryStock${window.Shopify.country}`].toLowerCase() === 'lowstock'
  );
};

window.utilities.cardHelpers.isInStock = (data) => {
  if (typeof data.totalInventory === 'number') {
    return data.totalInventory > 0;
  }

  return (
    data.flags[`inventoryStock${window.Shopify.country}`] &&
    data.flags[`inventoryStock${window.Shopify.country}`].toLowerCase() !== 'outofstock'
  );
};
